import React, {useEffect, useMemo} from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    Button,
    Container,
    FormControl,
    Grid,
    InputLabel,
    makeStyles,
    MenuItem,
    Paper,
    Select,
    ThemeProvider,
    Typography,
} from "@material-ui/core";

import { dynamicSearch, sortAndFilterProducts } from "../../../api/services/productService";
import { Creators as ProductActions } from "../../../store/ducks/products";
import { SORTING_TYPES as sort } from "../../../utils/js/constants";

import Layout from "../../Layout/Layout";
import { productsPageStyle, theme } from "./productsPageStyle";
import ListProducts from "../../ListProducts/ListProducts";
import RadioButton from "../../RadioButton/RadioButton";
import InputSearch from "../../InputSearch/InputSearch";
import ProductRegister from "../../ProductRegister/ProductRegister";
import CustomModal from "../../CustomModal/CustomModal";
import { notifySuccess } from "../../../utils/js/helpers";

const useStyles = makeStyles((theme) => productsPageStyle(theme));

const ProductsPage = ({ getProductList, deleteProduct, produtos }) => {
    const classes = useStyles();

    const [sortProduct, setSortProduct] = React.useState(sort.NOME);
    const [listProducts, setListProducts] = React.useState([]);
    const [segmentFlag, setSegmentFlag] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false)
    const [selectedProduct, setSelectedProduct] = React.useState(null);
    const [query, setQuery] = React.useState('')

    const computedProductList = useMemo(() => {
        const products = dynamicSearch(listProducts, query);
        
        return sortAndFilterProducts(products, sortProduct, segmentFlag);
    }, [listProducts, query, segmentFlag, sortProduct]);

    const { data, type } = produtos;

    useEffect(() => {
        if (!listProducts.length) {
            getProductList();
        }
    }, [getProductList, listProducts])

    useEffect(() => {
        if (type === "products/SEARCH_ALL") {
            setListProducts(data)
        }
    }, [data, type]);

    const handleClosingModal = () => {
        setShowModal(false)
        setSelectedProduct(null)
    }

    const handleEditingProduct = (product) => {
        setSelectedProduct(product)
        setShowModal(true)
    }

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.root}>
                <Layout title="Produtos">
                    <CustomModal open={showModal} onClose={handleClosingModal}>{(
                        <ProductRegister productToEdit={selectedProduct} onFinished={handleClosingModal}/>
                    )}
                    </CustomModal>

                    <main className={classes.content}>
                        <div className={classes.appBarSpacer} />
                        <Container maxWidth="lg" className={classes.container}>
                            <Paper className={classes.containerProducts}>
                                <Grid
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                >
                                    <Typography
                                        component="h1"
                                        variant="h5"
                                        noWrap
                                        className={classes.title}
                                    >
                                        Lista de produtos
                                    </Typography>

                                    <Button 
                                      variant="contained" 
                                      className={classes.registerButton} 
                                      onClick={() => setShowModal(true)}>
                                        cadastrar
                                    </Button>
                                </Grid>
                                <Grid
                                    container
                                    spacing={3}
                                    direction="row"
                                    alignItems="center"
                                >
                                    <Grid
                                        container
                                        item
                                        direction="row"
                                        alignItems="center"
                                        xs={6}
                                    >
                                        <InputLabel className={classes.label}>Filtrar por:</InputLabel>

                                        <FormControl
                                            variant="outlined"
                                            className={classes.filter}
                                        >
                                            <Select
                                                value={sortProduct}
                                                onChange={({target}) => setSortProduct(target.value)}
                                                className={classes.select}
                                            >
                                                <MenuItem value={sort.NOME} className={classes.selectItem}>
                                                    {sort.NOME}
                                                </MenuItem>
                                                <MenuItem value={sort.ESTOQUE_BAIXO} className={classes.selectItem}>
                                                    {sort.ESTOQUE_BAIXO}
                                                </MenuItem>
                                                <MenuItem value={sort.ESTOQUE_ALTO} className={classes.selectItem}>
                                                    {sort.ESTOQUE_ALTO}
                                                </MenuItem>
                                                <MenuItem value={sort.PRECO_ALTO} className={classes.selectItem}>
                                                    {sort.PRECO_ALTO}
                                                </MenuItem>
                                                <MenuItem value={sort.PRECO_BAIXO} className={classes.selectItem}>
                                                    {sort.PRECO_BAIXO}
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid container item direction="row" xs={6}>
                                        <InputLabel className={classes.label}>Buscar por segmentos:</InputLabel>
                                        <FormControl
                                            variant="outlined"
                                            className={classes.filterButton}
                                        >
                                            <RadioButton
                                                groupBySegment={() => setSegmentFlag(!segmentFlag)}
                                                value={segmentFlag}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <InputSearch getProduct={setQuery} />

                                <ListProducts
                                  listProducts={computedProductList}
                                  segmentFlag={segmentFlag}
                                  deleteProduct={(key) => {
                                      deleteProduct(key)
                                      notifySuccess("Sucesso ao excluir o produto!")
                                  }}
                                  onEditProduct={handleEditingProduct}
                                />
                            </Paper>
                        </Container>
                    </main>
                </Layout>
            </div>
        </ThemeProvider>
    );
};

const mapStateProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ProductActions, dispatch);
};

export default connect(mapStateProps, mapDispatchToProps)(ProductsPage);
